<template>
<div class='slide slide--article'>
  <div class='slide_label body-four-light'>
    {{ activity.subheadline }}
  </div>

  <h2 class='slide_headline h-two-light'>
    {{ activity.headline }}
  </h2>

  <div
    v-if='activity.instructions'
    class='slide_subheadline body-one-light'
  >
    {{ activity.instructions }}
  </div>

  <button
    class='slide_cta button-one-light'
    @click.prevent='toggleOverlay'
  >
    {{ article_button_name }}
  </button>
</div>
</template>

<script>
import CommonMixin from './common-mixin'

export default {
  mixins: [CommonMixin],

  props: ['toggleActivityOverlay'],

  computed: {
    article_button_name() {
      return this.activity.cta ? this.activity.cta : this.$t('read_the_article')
    }
  },

  methods: {
    toggleOverlay() {
      this.toggleActivityOverlay()

      if (typeof (dataLayer) !== 'undefined') {
        this.updateResult('clicked')

        const event = {
          event:                'resourceClick',
          pageCategory:         'resourceSlide',
          resourceTitle:        this.activity.headline,
          resourceSubTitle:     this.article_button_name,
          resourceID:           this.activity.id,
          resourceURL:          window.parent.location.href,
          resourceDestination:  'internal'
        }

        dataLayer.push(event)
      }
    }
  }
}
</script>

<style lang='sass' scoped>
// @import './article-v1'
</style>
